import { isAnyArray } from 'is-any-array';
export function convertToFloatArray(data) {
    if (isAnArray(data)) {
        return convertAnArray(data);
    }
    else {
        const newData = {};
        for (const key in data) {
            const currentData = data[key];
            newData[key] = convertAnArray(currentData);
        }
        return newData;
    }
}
function isAnArray(data) {
    return isAnyArray(data);
}
function convertAnArray(data) {
    if (isBidimensionalArray(data)) {
        return data.map(convertAnArrayToFloat);
    }
    return convertAnArrayToFloat(data);
}
function convertAnArrayToFloat(data) {
    return Float64Array.from(data);
}
function isBidimensionalArray(data) {
    return isAnyArray(data[0]);
}
//# sourceMappingURL=convertToFloatArray.js.map